<form #form="ngForm">
	<lgb-logo/>
	<div [loading]="loading()">
		<fieldset class="fieldset border-base-300 rounded-box w-xs border p-4 glass">
	  		<legend class="fieldset-legend">Mot de passe oublié ?</legend>
			<lgb-message [(msg)]="msg" [(error)]="error"></lgb-message>
			<label class="floating-label my-3">
			  <span>E-mail</span>
			  <input type="mail" placeholder="mail@site.com" name="email" class="input input-md" [(ngModel)]="mail" required email/>
			</label>
			<div class="btn-container">
				<a href="#" [routerLink]="router.get('login')" class="btn btn-link">Retour</a>
				<button (click)="forgot()" class="btn btn-primary btn-gradient" [disabled]="form.invalid">Valider</button>
			</div>
		</fieldset>
	</div>
</form>